<template>
	<main class="mypage terms_agreement">
		<article class="terms_info">
			<h6>약관동의</h6>
			<section>
				<ul class="terms_info_list">
					<li>
						<span>서비스 이용약관에 동의합니다.</span
						><button class="c_button showTerms" @click="$router.push('/my/terms-service')">
							약관보기<IconArrowNext
								width="18"
								height="18"
								icon-color="#C6C6D6"
								class="arrow_next"
								alt="개인정보 약관보기 아이콘"
							/>
						</button>
					</li>
					<li>
						<span>개인정보 수집.이용에 동의합니다.</span
						><button class="c_button showTerms" @click="$router.push('/my/privacy-policy')">
							약관보기
							<IconArrowNext
								width="18"
								height="18"
								icon-color="#C6C6D6"
								class="arrow_next"
								alt="개인정보 약관보기 아이콘"
							/>
						</button>
					</li>
				</ul>
			</section>

			<!-- 분기 처리 필요 회원가입 sns 및 기존 회원가입 -->
			<button class="c_button primary-fill agree" @click="onClickSignUp">모두동의</button>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { useRoute, useRouter } from 'vue-router';

// component
import IconArrowNext from '@/components/atom/icon/IconArrowNext.vue';

const route = useRoute();
const router = useRouter();
// -----function-----
const onClickSignUp = () => {
	type QueryType = {
		joinPath: string;
		name?: string;
		redirect?: string;
	};
	const query: QueryType = { joinPath: String(route.query.joinPath) };

	if (route.query.name) {
		query.name = String(route.query.name);
	}
	if (typeof route.query.redirect === 'string') {
		query.redirect = route.query.redirect;
	}
	router.push({
		name: 'auth/signup',
		query: query,
	});
};
</script>

<style lang="scss" scoped>
.terms_agreement {
	max-width: 40rem;
	.terms_info {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: var(--space-xxxx-large);
		.terms_info_list {
			display: flex;
			flex-direction: column;
			gap: var(--space-small);
			font-weight: var(--font-w-regular);
			font-size: var(--font-s-regular);
			line-height: 2.2rem;

			li {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.showTerms {
					color: var(--color-base-mid);
					font-weight: var(--font-w-medium);
					font-size: var(--font-s-small);
					line-height: 1.551rem;
					.arrow_next {
						color: var(--color-base-mid);
					}
					img {
						width: 1.8rem;
					}
				}
				.c_button {
					padding: 0rem;
					height: 3rem;
				}
			}
		}
		.agree {
			height: 4.8rem;
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
		}
	}
}
</style>
